<template>
  <b-modal
    id="destroy-advertiser-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
  >
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="text-center mt-3">
      <div class="mb-4">
        <i class="fa fa-warning font-size-large text-warning"></i>
      </div>
      <h2 class="highlighted-color1">
        <span>{{ $t('disable_advertiser') }}</span>
      </h2>
    </div>
    <div class="text-center mt-3">
      <p v-html="$t('want_to_inactivate_advertiser', {name: this.advertiser ? this.advertiser.name : ''})"></p>
      <p>{{ $t('info_inactivate_advertiser') }}</p>
      <div class="mt-3">
        <!-- MESSAGES -->
        <div
          class="mb-2 alert-message-card text-color2 font-size-small px-3 py-2"
          v-if="loader"
        >
          <p
            class="mb-0"
          >
            {{ $t('this_action_may_take_a_few_minutes') }}
          </p>
        </div> <!-- END MESSAGES -->
        <Button
          type="button"
          class="btn btn-color10"
          @click="submit"
          :loading="loader"
        >
          {{ $t('disable_advertiser') }}
        </Button>
      </div>
    </div>
  </b-modal>
</template>

<script>

import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  name: 'DestroyAdvertiserModal',
  props: ['advertiser'],
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      loader: false,
      content: null,
      content_type: 'error'
    }
  },
  methods: {
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
        await AdvertisersService.destroyAdvertiser(this.advertiser.id)
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('advertiser_successfully_deactivated')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$bvModal.hide('destroy-advertiser-modal')
        if (this.advertiser) this.$emit('advertiser-destroyed', this.advertiser)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
